import { Link, useNavigate } from "react-router";
import { CHECKER_LABEL, CHECKER_URL } from "../../lib/links";
import { FileStep } from "../upload/FileStep";

/**
 * First visit: no vendors yet, so the Vendors page is one drop target. The file goes straight into the
 * upload flow at the column step; nothing else is asked first.
 */
export function Onboarding() {
  const navigate = useNavigate();
  return (
    <div className="stack" style={{ gap: "var(--space-6)", paddingTop: "var(--space-4)" }}>
      <div style={{ maxWidth: "40rem" }}>
        <h1 style={{ fontSize: "var(--text-3xl)", marginBottom: "var(--space-2)" }}>
          Drop your vendor list.
        </h1>
        <p className="text-2" style={{ margin: 0, lineHeight: 1.55 }}>
          Any Excel or CSV from your ERP. One row per vendor with a name and an NTN or CNIC. We suggest the
          columns; you confirm. First check within 24 hours.
        </p>
      </div>
      <FileStep onUploaded={(upload) => void navigate("/upload", { state: { upload } })} />
      <div className="steps-3">
        <div>
          <strong>No ERP export?</strong>
          <span>Any spreadsheet works: one column of names and one of NTNs or CNICs, even a single row.</span>
        </div>
        <div>
          <strong>Want it on WhatsApp?</strong>
          <span>
            Messages go to your email until you add a number.{" "}
            <Link to="/settings#channels">Add a number</Link>
          </span>
        </div>
        <div>
          <strong>Check one vendor first?</strong>
          <span>
            The free checker at <a href={CHECKER_URL}>{CHECKER_LABEL}</a> needs no list.
          </span>
        </div>
      </div>
    </div>
  );
}
